module.exports = __webpack_public_path__ + "img/image18.96e4afe3.jpeg";